import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { dispatch, RootState } from 'src/store'
import styled from 'styled-components'
import { Text } from '../../elements'
import Material from '../Material'

const InsightContainer = styled(Flex).attrs({ flexDirection: 'column' })`
  padding-left: 28px;
  margin-bottom: 48px;
  border-width: 2px;
  border-left: solid;
  border-left-color: #ececec;
`

interface IConnectProps {
  lectureId: string
  chapterIdx: number
  insightId: string
}
type IInsightProps = ReturnType<typeof mapState> & IConnectProps

class Insight extends React.Component<IInsightProps> {
  public componentDidMount = () => {
    dispatch.insights.fetchInsights([this.props.insightId])
  }
  public render() {
    const { lectureId, chapterIdx, insightId, insight, isLoading } = this.props
    return (
      <InsightContainer>
        {isLoading ? (
          'Loading...'
        ) : (
          <React.Fragment>
            <Box mb={28}>
              <Text.SubtitleBold>
                {insight ? insight.text : null}
              </Text.SubtitleBold>
            </Box>
            {insight
              ? insight.materials.map((_, idx) => (
                  <Material
                    key={idx}
                    lectureId={lectureId}
                    chapterIdx={chapterIdx}
                    insightId={insightId}
                    materialIdx={idx}
                  />
                ))
              : []}
          </React.Fragment>
        )}
      </InsightContainer>
    )
  }
}

const mapState = (
  { insights, loading }: RootState,
  { insightId }: IConnectProps
) => {
  return {
    insight: insights[insightId] ? insights[insightId] : null,
    isLoading: loading.effects.insights.fetchInsights
  }
}

export default connect(mapState)(Insight)



// WEBPACK FOOTER //
// ./src/components/Insight/index.tsx